import { isNumber, isString, size } from 'lodash'
import humanFormat from 'human-format'
import moment from 'moment'
import { formatPhoneNumberForDisplay } from './phone'

export const US_DATE_FORMAT = 'MM/DD/YYYY'

const toFixed = (value, precision) => {
  let number = isNumber(value) ? value : Number(value) //humanFormat(value || 0, { decimals: 1 });
  return number.toFixed(precision)
}

const toFormattedDate = (value, format, convertToLocalTime) => {
  if (value != null) {
    let date = moment(value)

    return date.isValid() ? (convertToLocalTime ? date.local().format(format) : date.format(format)) : null
  }

  return null
}

const formatCount = collection => humanFormat(size(collection), { decimals: 1 })

/*const formatNumber = (total) => format(total || 0, { decimals: 1 });*/

const formatHours = (hours, decimals = 0) =>
  hours > 100000
    ? humanFormat(hours || 0, { decimals: 1 })
    : Intl.NumberFormat('en', { style: 'decimal', maximumFractionDigits: decimals }).format(hours || 0)

const formatDate = date => toFormattedDate(date, US_DATE_FORMAT)

const formatTime = (dateTime, convertToLocalTime = true) => toFormattedDate(dateTime, 'h:mm a', convertToLocalTime)

const formatRelativeTime = time => {
  const now = moment()
  const days = now.diff(time, 'days')
  if (days) {
    return `${days}d ago`
  }
  const hours = now.diff(time, 'hours')
  if (hours) {
    return `${hours}h ago`
  }
  const minutes = now.diff(time, 'minutes')
  if (minutes) {
    return `${minutes}m ago`
  }
  return 'Now'
}

const formatDateTime = (dateTime, convertToLocalTime = true) =>
  toFormattedDate(dateTime, 'MM/DD/YYYY hh:mm a', convertToLocalTime)
const formatDateTimeForExport = (dateTime, convertToLocalTime = true) =>
  toFormattedDate(dateTime, 'MM/DD/YYYY hh:mm:ss a', convertToLocalTime)

const formatNumber = total =>
  total > 100000
    ? humanFormat(total || 0, { decimals: 1 })
    : Intl.NumberFormat('en', { style: 'decimal', maximumFractionDigits: 0 }).format(total || 0)

const formatCurrency = amount =>
  amount > 100000
    ? '$' + humanFormat(amount || 0, { decimals: 1 })
    : '$' + Intl.NumberFormat('en', { style: 'decimal', maximumFractionDigits: 0 }).format(amount || 0)

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

//TODO this "real thing" should be called 'currency'
const formatMoney = amount => usdFormatter.format(amount)

const formatPhoneNumber = phone => formatPhoneNumberForDisplay(phone)

const formatName = person => {
  if (!person) return ''
  return `${person.givenName && person.givenName} ${person.familyName && person.familyName}`
}

const toUrlDate = datetime => (datetime ? moment(datetime).utc().format('YYYY-MM-DD') : null)
const toUrlDateTime = datetime => (datetime ? moment(datetime).clone().utc().toISOString() : null)

const toISOInTimezoneFromDateAndTime = (date, time, timeZone) => {
  const tzDate = moment.tz(moment.isMoment(date) ? date.format('YYYY-MM-DD') : date, timeZone)
  return tzDate.set({ hours: time.hours() }).set({ minutes: time.minutes() }).format()
}

const formatAddress = address => {
  if (!address) return ''
  const { line1, line2, city, state, zip } = address
  return `${line1}${line2 || ''}, ${city}, ${state} ${zip || ''}`
}

export const DEFAULT_TIME_ZONE = 'America/New_York'

export default {
  count: formatCount,
  number: formatNumber,
  hours: formatHours,
  date: formatDate,
  dateForUrl: toUrlDate,
  dateTimeForUrl: toUrlDateTime,
  datetime: formatDateTime,
  datetimeForExport: formatDateTimeForExport,
  datetimeInTimezone: toISOInTimezoneFromDateAndTime,
  fixedPoint: toFixed,
  currency: formatCurrency,
  money: formatMoney, //TODO this should be currency >_>
  phoneNumber: formatPhoneNumber,
  name: formatName,
  timeAgo: formatRelativeTime,
  time: formatTime,
  address: formatAddress,
}
